import { Colors } from '../../../colors';

export enum SvgType {
  Google = 'Google',
  Facebook = 'Facebook',
  RadioUnchecked = 'RadioUnchecked',
  RadioChecked = 'RadioChecked',
  AddButton = 'AddButton',
  Circle = 'Circle',
  Hamburger = 'Hamburger',
  Trash = 'Trash',
  Mail = 'Mail',
  MailNotFill = 'MailNotFill',
  Edit = 'Edit',
  CheckIn = 'CheckIn',
  CheckOut = 'CheckOut',
  Plus = 'Plus',
  Check = 'Check',
  Minus = 'Minus',
  Close = 'Close',
  Error = 'Error',
  Alert = 'Alert',
  EditCsv = 'EditCsv',
  Eye = 'Eye',
  Add = 'Add',
  Info = 'Info',
  UploadCsv = 'UploadCsv',
  LogoCsv = 'LogoCsv',
  LoginIcon = 'LoginIcon',
  InstagramSvg = 'InstagramSvg',
  FacebookSvg = 'FacebookSvg',
  Cancel = 'Cancel',
  Search = 'Search',
  Note = 'Note',
  ActiveEvent = 'ActiveEvent',
  MapIcon = 'MapIcon',
  Headphones = 'Headphones',
  Camera = 'Camera',
  Wallet = 'Wallet',
  Wine = 'Wine',
  SvgUrl = 'SvgUrl',
  InfoCsv = 'InfoCsv',
  ReloadCsv = 'ReloadCsv',
  AlertTb = 'AlertTb',
  Mixer = 'Mixer',
  LiveStreaming = 'LiveStreaming',
  WallLed = 'WallLed',
  WelcomeCoffee = 'WelcomeCoffee',
  BuffetAndAperitivi = 'BuffetAndAperitivi',
  HandleAttendees = 'HandleAttendees',
  AlertDuplicateAttendees = 'AlertDuplicateAttendees',
  MinusServices = 'MinusServices'
}

const Svg = {
  [SvgType.Google]: () => (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4_467)">
        <path
          d="M16.9919 8.97032C16.9919 8.27384 16.934 7.76559 16.8089 7.23853H8.66931V10.3821H13.447C13.3508 11.1633 12.8306 12.3398 11.6747 13.1304L11.6585 13.2356L14.232 15.1837L14.4103 15.2011C16.0478 13.7234 16.9919 11.5492 16.9919 8.97032Z"
          fill="#4285F4"
        />
        <path
          d="M8.66931 17.2529C11.01 17.2529 12.975 16.4999 14.4103 15.201L11.6747 13.1304C10.9426 13.6292 9.96005 13.9774 8.66931 13.9774C6.37677 13.9774 4.431 12.4998 3.73739 10.4574L3.63572 10.4658L0.959679 12.4894L0.924683 12.5845C2.35029 15.3516 5.27861 17.2529 8.66931 17.2529Z"
          fill="#34A853"
        />
        <path
          d="M3.73741 10.4574C3.55439 9.93032 3.44848 9.36556 3.44848 8.78204C3.44848 8.19846 3.55439 7.63376 3.72778 7.1067L3.72293 6.99445L1.01336 4.93835L0.924707 4.97956C0.337145 6.12784 0 7.4173 0 8.78204C0 10.1468 0.337145 11.4362 0.924707 12.5845L3.73741 10.4574Z"
          fill="#FBBC05"
        />
        <path
          d="M8.66931 3.58663C10.2972 3.58663 11.3953 4.27371 12.0214 4.84788L14.4681 2.51369C12.9655 1.14895 11.01 0.311279 8.66931 0.311279C5.27861 0.311279 2.35029 2.21249 0.924683 4.9796L3.72776 7.10674C4.431 5.06434 6.37677 3.58663 8.66931 3.58663Z"
          fill="#EB4335"
        />
      </g>
      <defs>
        <clipPath id="clip0_4_467">
          <rect
            width="17"
            height="17"
            fill="white"
            transform="translate(0 0.311279)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  [SvgType.Facebook]: () => (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.725 22.8113V15.0663H18.325L18.714 12.0483H15.724V10.1213C15.724 9.24728 15.967 8.65128 17.221 8.65128H18.819V5.95128C18.0451 5.86892 17.2673 5.82886 16.489 5.83128C14.185 5.83128 12.608 7.23828 12.608 9.82128V12.0483H10V15.0663H12.607V22.8113H3.104C2.494 22.8113 2 22.3173 2 21.7073V3.91528C2 3.30528 2.494 2.81128 3.104 2.81128H20.896C21.506 2.81128 22 3.30528 22 3.91528V21.7073C22 22.3173 21.506 22.8113 20.896 22.8113H15.725Z"
        fill="white"
      />
    </svg>
  ),
  [SvgType.BuffetAndAperitivi]: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="91"
      height="91"
      viewBox="0 0 91 91"
      fill="#3579ba"
    >
      <g
        id="Raggruppa_1047"
        data-name="Raggruppa 1047"
        transform="translate(-1371 -2281)"
      >
        <rect
          id="Rettangolo_1269"
          data-name="Rettangolo 1269"
          fill="#c7e4ff"
          width="91"
          height="91"
          rx="10"
          transform="translate(1371 2281)"
        />
        <g id="Raggruppa_1042" data-name="Raggruppa 1042">
          <path
            id="Icon_map-food"
            data-name="Icon map-food"
            d="M35.2,10.911,32.37,33.12H22.8L19.979,10.8H31.662l2.309-7.975,1.309.395-2.215,7.675,2.139.017ZM18.626,23.76s.358-2.88-4.6-2.88h-7.9c-4.955,0-4.6,2.88-4.6,2.88H18.626ZM1.515,30.24s-.351,2.88,4.6,2.88h7.9c4.962,0,4.6-2.88,4.6-2.88H1.515ZM17.884,28.8A1.656,1.656,0,0,0,19.352,27a1.654,1.654,0,0,0-1.468-1.8H2.189A1.657,1.657,0,0,0,.72,27a1.659,1.659,0,0,0,1.469,1.8h15.7Z"
            transform="translate(1388.385 2309.028)"
          />
          <path
            id="Icon_awesome-wine-glass-alt"
            data-name="Icon awesome-wine-glass-alt"
            d="M12.781,27.455H10.414V20.521A8.559,8.559,0,0,0,17.006,11.4L16.062.861A.939.939,0,0,0,15.132,0H1.909A.938.938,0,0,0,.98.861L.036,11.4a8.559,8.559,0,0,0,6.592,9.122v6.934H4.26a2.367,2.367,0,0,0-2.367,2.367.473.473,0,0,0,.473.473H14.674a.473.473,0,0,0,.473-.473A2.367,2.367,0,0,0,12.781,27.455ZM3.654,2.84h9.734l.424,4.734H3.23Z"
            transform="translate(1426.854 2311.853)"
          />
        </g>
      </g>
    </svg>
  ),
  [SvgType.WelcomeCoffee]: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="91"
      height="91"
      viewBox="0 0 91 91"
      fill="#3579ba"
    >
      <g
        id="Raggruppa_1048"
        data-name="Raggruppa 1048"
        transform="translate(-1029 -2281)"
      >
        <rect
          id="Rettangolo_44"
          data-name="Rettangolo 44"
          fill="#c7e4ff"
          width="91"
          height="91"
          rx="10"
          transform="translate(1029 2281)"
        />
        <path
          id="Icon_awesome-coffee"
          data-name="Icon awesome-coffee"
          d="M13.5,27H27a6.752,6.752,0,0,0,6.75-6.75H36a9,9,0,0,0,0-18H8.438A1.683,1.683,0,0,0,6.75,3.938V20.25A6.752,6.752,0,0,0,13.5,27ZM36,6.75a4.5,4.5,0,0,1,0,9H33.75v-9Zm3.354,27H3.4c-3.347,0-4.289-4.5-2.531-4.5H41.878c1.758,0,.83,4.5-2.524,4.5Z"
          transform="translate(1052.002 2309)"
        />
      </g>
    </svg>
  ),
  [SvgType.WallLed]: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="91"
      height="91"
      viewBox="0 0 91 91"
      fill="#3579ba"
    >
      <g
        id="Raggruppa_1049"
        data-name="Raggruppa 1049"
        transform="translate(-687 -2281)"
      >
        <rect
          id="Rettangolo_1268"
          data-name="Rettangolo 1268"
          fill="#c7e4ff"
          width="91"
          height="91"
          rx="10"
          transform="translate(687 2281)"
        />
        <path
          id="Icon_material-featured-play-list"
          data-name="Icon material-featured-play-list"
          d="M31.5,4.5H4.5a3.009,3.009,0,0,0-3,3v21a3.009,3.009,0,0,0,3,3h27a3.009,3.009,0,0,0,3-3V7.5A3.009,3.009,0,0,0,31.5,4.5ZM18,16.5H4.5v-3H18Zm0-6H4.5v-3H18Z"
          transform="translate(714.5 2309)"
        />
      </g>
    </svg>
  ),
  [SvgType.LiveStreaming]: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="91"
      height="91"
      viewBox="0 0 91 91"
      fill="#3579ba"
    >
      <g
        id="Raggruppa_1050"
        data-name="Raggruppa 1050"
        transform="translate(-345 -2277)"
      >
        <rect
          id="Rettangolo_44"
          data-name="Rettangolo 44"
          width="91"
          height="91"
          rx="10"
          transform="translate(345 2277)"
          fill="#c7e4ff"
        />
        <path
          id="Icon_material-video-call"
          data-name="Icon material-video-call"
          d="M34.868,18.761V11.169A2.176,2.176,0,0,0,32.7,9H6.669A2.176,2.176,0,0,0,4.5,11.169V32.86A2.176,2.176,0,0,0,6.669,35.03H32.7a2.176,2.176,0,0,0,2.169-2.169V25.269l8.677,8.677V10.085ZM28.36,24.184H21.853v6.507H17.515V24.184H11.007V19.846h6.507V13.338h4.338v6.507H28.36Z"
          transform="translate(369.501 2300.485)"
        />
      </g>
    </svg>
  ),
  [SvgType.Mixer]: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="91"
      height="91"
      viewBox="0 0 91 91"
      fill="#3579ba"
    >
      <g
        id="Raggruppa_1043"
        data-name="Raggruppa 1043"
        transform="translate(-345 -1981)"
      >
        <rect
          id="Rettangolo_44"
          data-name="Rettangolo 44"
          width="91"
          height="91"
          rx="10"
          transform="translate(345 1981)"
          fill="#c7e4ff"
        />
        <g
          id="Icon_material-record-voice-over"
          data-name="Icon material-record-voice-over"
          transform="translate(372.501 2009.25)"
        >
          <path
            id="Tracciato_46"
            data-name="Tracciato 46"
            d="M19.5,13.5a6,6,0,1,1-6-6,6,6,0,0,1,6,6Z"
          />
          <path
            id="Tracciato_47"
            data-name="Tracciato 47"
            d="M13.5,22.5c-4.005,0-12,2.01-12,6v3h24v-3C25.5,24.51,17.505,22.5,13.5,22.5ZM25.14,8.04l-2.52,2.535a4.976,4.976,0,0,1,0,5.835l2.52,2.535A7.676,7.676,0,0,0,25.14,8.04ZM30.1,3,27.66,5.445a11.968,11.968,0,0,1,0,16.11L30.1,24A14.744,14.744,0,0,0,30.1,3Z"
          />
        </g>
      </g>
    </svg>
  ),
  [SvgType.RadioUnchecked]: () => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 57 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="28.25"
        cy="29.1609"
        r="26.75"
        stroke="#B6B0A0"
        strokeWidth="3"
      />
    </svg>
  ),
  [SvgType.RadioChecked]: (options?: IconOptions) => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 58 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="29.2188"
        cy="29.1609"
        r="26.75"
        stroke="#B6B0A0"
        strokeWidth="3"
      />
      <circle
        cx="29.2188"
        cy="29.1609"
        r="12.1885"
        fill={options?.color ? options?.color : '#3B7CB0'}
      />
    </svg>
  ),
  [SvgType.AddButton]: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
    >
      <g data-name="Raggruppa 48" transform="translate(-3203 -1473)">
        <circle
          data-name="Ellisse 5"
          cx="14"
          cy="14"
          r="14"
          transform="translate(3203 1473)"
          fill="#fff"
        />
        <path
          data-name="Icon ionic-ios-add-circle"
          d="M24.363 19.125h-5.238v5.238a1.125 1.125 0 0 1-2.25 0v-5.238h-5.238a1.125 1.125 0 0 1 0-2.25h5.238v-5.238a1.125 1.125 0 0 1 2.25 0v5.238h5.238a1.125 1.125 0 0 1 0 2.25z"
          transform="translate(3199 1469)"
          fill="#357abb"
        />
      </g>
    </svg>
  ),
  [SvgType.Circle]: (options?: IconOptions) => (
    <svg
      width="11"
      height="11"
      viewBox="0 0 11 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="5.5" cy="5.50006" r="4.62506" fill={options?.color} />
    </svg>
  ),
  [SvgType.Hamburger]: () => (
    <svg
      width="45"
      height="24"
      viewBox="0 0 45 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M10.3889 1H34.3572" stroke="#3B7CB0" />
      <path d="M10.3889 12H34.3572" stroke="#3B7CB0" />
      <path d="M10.3889 23H34.3572" stroke="#3B7CB0" />
    </svg>
  ),
  [SvgType.Trash]: (options?: IconOptions) => (
    <svg
      width="23"
      height="23"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.14005 0.864258C7.41728 0.332031 7.98714 0 8.60835 0H14.7896C15.4108 0 15.9807 0.332031 16.2579 0.864258L16.6275 1.5625H21.5561C22.4648 1.5625 23.199 2.26074 23.199 3.125C23.199 3.98926 22.4648 4.6875 21.5561 4.6875H1.84183C0.933126 4.6875 0.198975 3.98926 0.198975 3.125C0.198975 2.26074 0.933126 1.5625 1.84183 1.5625H6.7704L7.14005 0.864258ZM1.84183 6.25H21.5561V21.875C21.5561 23.5986 20.0827 25 18.2704 25H5.12755C3.31527 25 1.84183 23.5986 1.84183 21.875V6.25ZM6.7704 9.375C6.31862 9.375 5.94897 9.72656 5.94897 10.1562V21.0938C5.94897 21.5234 6.31862 21.875 6.7704 21.875C7.22219 21.875 7.59183 21.5234 7.59183 21.0938V10.1562C7.59183 9.72656 7.22219 9.375 6.7704 9.375ZM11.699 9.375C11.2472 9.375 10.8775 9.72656 10.8775 10.1562V21.0938C10.8775 21.5234 11.2472 21.875 11.699 21.875C12.1508 21.875 12.5204 21.5234 12.5204 21.0938V10.1562C12.5204 9.72656 12.1508 9.375 11.699 9.375ZM16.6275 9.375C16.1758 9.375 15.8061 9.72656 15.8061 10.1562V21.0938C15.8061 21.5234 16.1758 21.875 16.6275 21.875C17.0793 21.875 17.449 21.5234 17.449 21.0938V10.1562C17.449 9.72656 17.0793 9.375 16.6275 9.375Z"
        fill={options?.color ? options.color : 'red'}
      />
    </svg>
  ),
  [SvgType.Mail]: () => (
    <svg
      width="20"
      height="15"
      viewBox="0 0 20 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.11457 0.218201C1.09447 0.218201 0.266846 1.04583 0.266846 2.06593C0.266846 2.64719 0.540155 3.19381 1.00594 3.54411L9.38229 9.82637C9.82112 10.1536 10.4216 10.1536 10.8605 9.82637L19.2368 3.54411C19.7026 3.19381 19.9759 2.64719 19.9759 2.06593C19.9759 1.04583 19.1483 0.218201 18.1282 0.218201H2.11457ZM0.266846 4.52956V12.5364C0.266846 13.8952 1.37163 15 2.73048 15H17.5123C18.8711 15 19.9759 13.8952 19.9759 12.5364V4.52956L11.5996 10.8118C10.7219 11.4701 9.52087 11.4701 8.6432 10.8118L0.266846 4.52956Z"
        fill="#8f8f8f"
      />
    </svg>
  ),
  [SvgType.Edit]: () => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.4219 0.847656C17.5664 -0.00781251 16.1836 -0.00781251 15.3281 0.847656L14.1523 2.01953L17.9766 5.84375L19.1523 4.66797C20.0078 3.8125 20.0078 2.42969 19.1523 1.57422L18.4219 0.847656ZM6.73437 9.44141C6.49609 9.67969 6.3125 9.97266 6.20703 10.2969L5.05078 13.7656C4.9375 14.1016 5.02734 14.4727 5.27734 14.7266C5.52734 14.9805 5.89844 15.0664 6.23828 14.9531L9.70703 13.7969C10.0273 13.6914 10.3203 13.5078 10.5625 13.2695L17.0977 6.73047L13.2695 2.90234L6.73437 9.44141ZM3.75 2.5C1.67969 2.5 0 4.17969 0 6.25V16.25C0 18.3203 1.67969 20 3.75 20H13.75C15.8203 20 17.5 18.3203 17.5 16.25V12.5C17.5 11.8086 16.9414 11.25 16.25 11.25C15.5586 11.25 15 11.8086 15 12.5V16.25C15 16.9414 14.4414 17.5 13.75 17.5H3.75C3.05859 17.5 2.5 16.9414 2.5 16.25V6.25C2.5 5.55859 3.05859 5 3.75 5H7.5C8.19141 5 8.75 4.44141 8.75 3.75C8.75 3.05859 8.19141 2.5 7.5 2.5H3.75Z"
        fill="#3B7CB0"
      />
    </svg>
  ),
  [SvgType.CheckIn]: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10.171"
      height="10.171"
      viewBox="0 0 10.171 10.171"
    >
      <g data-name="Icon feather-log-in">
        <path
          data-name="Tracciato 31"
          d="M22.5 4.5h2.038a1.019 1.019 0 0 1 1.019 1.019v7.133a1.019 1.019 0 0 1-1.019 1.019H22.5"
          transform="translate(-15.886 -4)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          data-name="Tracciato 32"
          d="m15 15.6 2.548-2.548L15 10.5"
          transform="translate(-10.933 -7.962)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          data-name="Tracciato 33"
          d="M10.614 18H4.5"
          transform="translate(-4 -12.914)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  ),
  [SvgType.CheckOut]: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10.171"
      height="10.171"
      viewBox="0 0 10.171 10.171"
    >
      <g data-name="Icon feather-log-out">
        <path
          data-name="Tracciato 34"
          d="M7.557 13.671H5.519A1.019 1.019 0 0 1 4.5 12.652V5.519A1.019 1.019 0 0 1 5.519 4.5h2.038"
          transform="translate(-4 -4)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          data-name="Tracciato 35"
          d="m24 15.6 2.548-2.548L24 10.5"
          transform="translate(-16.876 -7.962)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          data-name="Tracciato 36"
          d="M19.614 18H13.5"
          transform="translate(-9.943 -12.914)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  ),
  [SvgType.Plus]: () => (
    <svg
      fill="#000000"
      version="1.1"
      id="Capa_1"
      width="20"
      height="20"
      viewBox="0 0 45.402 45.402"
    >
      <g>
        <path
          d="M41.267,18.557H26.832V4.134C26.832,1.851,24.99,0,22.707,0c-2.283,0-4.124,1.851-4.124,4.135v14.432H4.141
        c-2.283,0-4.139,1.851-4.138,4.135c-0.001,1.141,0.46,2.187,1.207,2.934c0.748,0.749,1.78,1.222,2.92,1.222h14.453V41.27
        c0,1.142,0.453,2.176,1.201,2.922c0.748,0.748,1.777,1.211,2.919,1.211c2.282,0,4.129-1.851,4.129-4.133V26.857h14.435
        c2.283,0,4.134-1.867,4.133-4.15C45.399,20.425,43.548,18.557,41.267,18.557z"
        />
      </g>
    </svg>
  ),
  [SvgType.Check]: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29.25"
      height="29.25"
      viewBox="0 0 29.25 29.25"
    >
      <path
        data-name="Icon ionic-ios-checkmark-circle"
        d="M18 3.375A14.625 14.625 0 1 0 32.625 18 14.623 14.623 0 0 0 18 3.375zm7.488 10.582-9.4 9.443h-.008a1.27 1.27 0 0 1-.816.387 1.231 1.231 0 0 1-.823-.4L10.5 19.448a.28.28 0 0 1 0-.4l1.256-1.248a.272.272 0 0 1 .394 0l3.122 3.122 8.578-8.641a.278.278 0 0 1 .2-.084.255.255 0 0 1 .2.084l1.23 1.273a.277.277 0 0 1 .008.403z"
        transform="translate(-3.375 -3.375)"
        fill="#3579ba"
      />
    </svg>
  ),
  [SvgType.Minus]: () => (
    <svg
      fill="#000000"
      version="1.1"
      id="Capa_1"
      width="20"
      height="20"
      viewBox="0 0 83 83"
    >
      <g>
        <path d="M81,36.166H2c-1.104,0-2,0.896-2,2v6.668c0,1.104,0.896,2,2,2h79c1.104,0,2-0.896,2-2v-6.668C83,37.062,82.104,36.166,81,36.166z" />
      </g>
    </svg>
  ),
  [SvgType.Close]: (options?: IconOptions) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={options?.size === 'small' ? '10.426' : '13.426'}
      height={options?.size === 'small' ? '10.423' : '13.423'}
      viewBox="0 0 13.426 13.423"
    >
      <path
        fill={options?.color ? options?.color : 'black'}
        data-name="Icon ionic-ios-close"
        d="m8.304 6.711 4.8-4.8A1.124 1.124 0 0 0 11.515.327l-4.8 4.8-4.8-4.8A1.124 1.124 0 1 0 .331 1.911l4.8 4.8-4.8 4.8a1.124 1.124 0 0 0 1.584 1.584l4.8-4.8 4.8 4.8a1.124 1.124 0 1 0 1.584-1.584z"
      />
    </svg>
  ),
  [SvgType.Error]: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29.25"
      height="29.25"
      viewBox="0 0 29.25 29.25"
    >
      <path
        data-name="Icon ionic-md-close-circle"
        d="M18 3.375A14.625 14.625 0 1 0 32.625 18 14.574 14.574 0 0 0 18 3.375zm7.313 19.89-2.048 2.047L18 20.047l-5.265 5.265-2.048-2.047L15.953 18l-5.265-5.265 2.048-2.047L18 15.953l5.265-5.265 2.048 2.047L20.047 18z"
        transform="translate(-3.375 -3.375)"
        fill="#fc4545"
      />
    </svg>
  ),
  [SvgType.Alert]: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29.25"
      height="29.25"
      viewBox="0 0 29.25 29.25"
    >
      <path
        data-name="Icon ionic-md-alert"
        d="M18 3.375A14.625 14.625 0 1 0 32.625 18 14.668 14.668 0 0 0 18 3.375zm1.688 21.938h-3.375V22.5h3.375zm0-6.187h-3.375v-9h3.375z"
        transform="translate(-3.375 -3.375)"
        fill="#ffb745"
      />
    </svg>
  ),
  [SvgType.EditCsv]: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11.232"
      height="9.982"
      viewBox="0 0 11.232 9.982"
    >
      <path
        data-name="Icon awesome-edit"
        d="M7.851 1.621 9.61 3.38a.191.191 0 0 1 0 .269L5.351 7.908l-1.81.2a.379.379 0 0 1-.419-.415l.2-1.81 4.26-4.262a.191.191 0 0 1 .269 0zm3.159-.447-.952-.952a.763.763 0 0 0-1.076 0l-.69.69a.191.191 0 0 0 0 .269l1.759 1.759a.191.191 0 0 0 .269 0l.69-.69a.763.763 0 0 0 0-1.076zM7.488 6.749v1.985h-6.24V2.493h4.481a.24.24 0 0 0 .171-.067l.78-.78a.234.234 0 0 0-.166-.4H.936A.936.936 0 0 0 0 2.182v6.864a.936.936 0 0 0 .936.936H7.8a.936.936 0 0 0 .936-.936V5.969a.234.234 0 0 0-.4-.166l-.78.78a.24.24 0 0 0-.068.166z"
      />
    </svg>
  ),
  [SvgType.Eye]: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12.979"
      height="9.712"
      viewBox="0 0 12.979 9.712"
    >
      <g data-name="Icon feather-eye">
        <path
          data-name="Tracciato 14"
          d="M1.5 10.356S3.678 6 7.49 6s5.99 4.356 5.99 4.356-2.18 4.356-5.99 4.356-5.99-4.356-5.99-4.356z"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          transform="translate(-1 -5.5)"
        />
        <path
          data-name="Tracciato 15"
          d="M16.767 15.134a1.634 1.634 0 1 1-1.633-1.634 1.634 1.634 0 0 1 1.633 1.634z"
          transform="translate(-8.644 -10.277)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  ),
  [SvgType.Add]: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8.555"
      height="8.555"
      viewBox="0 0 8.555 8.555"
    >
      <path
        data-name="Icon ionic-ios-add-circle"
        d="M7.912 4.92H4.92v2.992a.643.643 0 0 1-1.285 0V4.92H.642a.643.643 0 1 1 0-1.285h2.992V.642a.643.643 0 1 1 1.285 0v2.992h2.992a.643.643 0 0 1 0 1.285z"
      />
    </svg>
  ),
  [SvgType.Info]: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
    >
      <path
        data-name="Icon awesome-info-circle"
        d="M7.563.563a7 7 0 1 0 7 7 7 7 0 0 0-7-7zm0 3.1a1.185 1.185 0 1 1-1.186 1.19 1.185 1.185 0 0 1 1.186-1.186zm1.581 7.169a.339.339 0 0 1-.339.339H6.321a.339.339 0 0 1-.339-.339v-.677a.339.339 0 0 1 .339-.339h.339V8.014h-.339a.339.339 0 0 1-.339-.339V7a.339.339 0 0 1 .339-.339h1.806A.339.339 0 0 1 8.466 7v2.821H8.8a.339.339 0 0 1 .339.339z"
        transform="translate(-.563 -.563)"
        fill="#3579ba"
      />
    </svg>
  ),
  [SvgType.UploadCsv]: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="42.239"
      height="56.319"
      viewBox="0 0 42.239 56.319"
    >
      <path
        data-name="Icon awesome-file-upload"
        d="M24.64 14.96V0h-22A2.634 2.634 0 0 0 0 2.64v51.039a2.634 2.634 0 0 0 2.64 2.64H39.6a2.634 2.634 0 0 0 2.64-2.64V17.6H27.28a2.648 2.648 0 0 1-2.64-2.64zm7.17 23.761h-7.17v8.8a1.759 1.759 0 0 1-1.76 1.76h-3.52a1.759 1.759 0 0 1-1.76-1.76v-8.8h-7.17a1.76 1.76 0 0 1-1.24-3.01L19.8 25.184a1.876 1.876 0 0 1 2.644 0l10.603 10.527a1.759 1.759 0 0 1-1.238 3.009zm9.66-27.171L30.7.77A2.638 2.638 0 0 0 28.831 0h-.671v14.08h14.08v-.671a2.632 2.632 0 0 0-.771-1.859z"
        fill="#3579ba"
      />
    </svg>
  ),
  [SvgType.LogoCsv]: () => (
    <svg
      height="33"
      viewBox="0 0 252 33"
      width="252"
      xmlns="http://www.w3.org/2000/svg"
    >
      <text
        fill="#3579ba"
        fontFamily="Inter-Bold, Inter"
        fontSize="27"
        fontWeight="700"
        transform="translate(40 26)"
      >
        <tspan x="0" y="0">
          Skyline Center
        </tspan>
      </text>
      <path
        d="m2.934 23.587-2.368-4.912a4.191 4.191 0 0 1 -.266-.554c-.033-.06-.045-.092-.039-.1a4.256 4.256 0 0 1 -.261-1.469v-12.414a4.071 4.071 0 0 1 4-4.138h20a4.071 4.071 0 0 1 4 4.138v12.414a4.07 4.07 0 0 1 -4 4.137h-18.065l-1.616 2.9a.787.787 0 0 1 -1.385 0z"
        fill="#3579ba"
        transform="translate(0 5)"
      />
      <g fill="#fff">
        <ellipse cx="14.5" cy="16" rx="2.5" ry="2" />
        <circle cx="8" cy="16" r="2" />
        <ellipse cx="20.5" cy="16" rx="2.5" ry="2" />
      </g>
    </svg>
  ),
  [SvgType.LoginIcon]: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13.141"
      height="13.141"
      viewBox="0 0 13.141 13.141"
    >
      <path
        id="Icon_awesome-user-alt"
        data-name="Icon awesome-user-alt"
        d="M6.571,7.392a3.7,3.7,0,1,0-3.7-3.7A3.7,3.7,0,0,0,6.571,7.392Zm3.285.821H8.442a4.468,4.468,0,0,1-3.742,0H3.285A3.285,3.285,0,0,0,0,11.5v.411a1.232,1.232,0,0,0,1.232,1.232H11.909a1.232,1.232,0,0,0,1.232-1.232V11.5A3.285,3.285,0,0,0,9.856,8.213Z"
      />
    </svg>
  ),
  [SvgType.FacebookSvg]: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31.5"
      height="31.5"
      viewBox="0 0 31.5 31.5"
    >
      <path
        id="Icon_awesome-facebook-square"
        data-name="Icon awesome-facebook-square"
        className="cls-1"
        d="M28.125,2.25H3.375A3.375,3.375,0,0,0,0,5.625v24.75A3.375,3.375,0,0,0,3.375,33.75h9.65V23.041H8.6V18h4.43V14.158c0-4.37,2.6-6.784,6.586-6.784a26.836,26.836,0,0,1,3.9.34V12h-2.2a2.521,2.521,0,0,0-2.842,2.723V18h4.836l-.773,5.041H18.475V33.75h9.65A3.375,3.375,0,0,0,31.5,30.375V5.625A3.375,3.375,0,0,0,28.125,2.25Z"
        transform="translate(0 -2.25)"
      />
    </svg>
  ),
  [SvgType.InstagramSvg]: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31.5"
      height="31.5"
      viewBox="0 0 31.5 31.5"
    >
      <path
        id="Icon_zocial-instagram"
        data-name="Icon zocial-instagram"
        className="cls-1"
        d="M2.841,31.522a3.745,3.745,0,0,1-1.723-.979A3.466,3.466,0,0,1,.163,28.9C.052,28.463.046,28.05.046,15.894.04,2.236.022,2.987.379,2.218A3.674,3.674,0,0,1,2.17.439C2.964.088,2.188.106,15.951.125L28.63.137l.394.135a3.733,3.733,0,0,1,2.364,2.364l.135.394.012,12.679c.018,14.083.049,13.03-.4,13.941a3.656,3.656,0,0,1-1.557,1.557c-.9.443.123.412-13.812.406C5.112,31.608,3.155,31.6,2.841,31.522Zm24.534-3.748c.5-.357.517-.394.535-2.739.018-2.284.006-2.4-.369-2.764-.339-.332-.5-.351-2.727-.345l-2.031.006-.277.148a1.514,1.514,0,0,0-.455.431l-.185.271-.006,2.037c-.006,1.114.018,2.13.049,2.247a1.15,1.15,0,0,0,.628.776l.308.154,2.136-.018,2.13-.018ZM17.022,21.8a6.109,6.109,0,0,0,4.715-4.739,7.519,7.519,0,0,0,.068-2,6.2,6.2,0,0,0-3.158-4.53,6.6,6.6,0,0,0-1.625-.6c-.117-.012-.363-.049-.548-.08a6.08,6.08,0,0,0-5.49,2.351,6.022,6.022,0,0,0,.117,7.478,6.137,6.137,0,0,0,4.062,2.21A6.424,6.424,0,0,0,17.022,21.8ZM6.306,17.8a9.768,9.768,0,0,1,.812-6.247,9.054,9.054,0,0,1,1.84-2.53,9.6,9.6,0,0,1,8.377-2.733,9.751,9.751,0,0,1,7.842,7.14,9.559,9.559,0,0,1,.252,3.447,6.777,6.777,0,0,1-.252,1.329c-.018.031-.012.055.018.062.234.025,2.628.018,2.671-.012s.049-2.751.043-6.869L27.892,4.55l-.185-.265a1.538,1.538,0,0,0-.462-.406l-.277-.142-11.239.018L4.5,3.769l-.252.166a1.619,1.619,0,0,0-.394.4L3.7,4.569l-.018,6.8c-.006,3.742-.006,6.826.012,6.863a6.624,6.624,0,0,0,1.373.062H6.417Z"
        transform="translate(-0.044 -0.117)"
      />
    </svg>
  ),
  [SvgType.Cancel]: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11.667"
      height="15"
      viewBox="0 0 11.667 15"
    >
      <path
        data-name="Icon material-delete"
        d="M8.333 17.833A1.672 1.672 0 0 0 10 19.5h6.667a1.672 1.672 0 0 0 1.667-1.667v-10h-10zm10.833-12.5H16.25l-.833-.833H11.25l-.833.833H7.5V7h11.667z"
        transform="translate(-7.5 -4.5)"
        fill="#fff"
      />
    </svg>
  ),
  [SvgType.Search]: (options?: IconOptions) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15.212"
      height="15.212"
      viewBox="0 0 15.212 15.212"
    >
      <path
        data-name="Icon ionic-md-search"
        d="M10.835 9.562h-.693l-.26-.217a5.754 5.754 0 0 0 1.344-3.694 5.613 5.613 0 1 0-5.591 5.65 5.809 5.809 0 0 0 3.684-1.347l.26.217v.7l4.334 4.346 1.3-1.3zm-5.2 0a3.912 3.912 0 1 1 3.9-3.912 3.89 3.89 0 0 1-3.901 3.912z"
        fill={options ? options.color : Colors.White}
      />
    </svg>
  ),
  [SvgType.MailNotFill]: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10.917"
      height="8.62"
      viewBox="0 0 10.917 8.62"
    >
      <g data-name="Icon feather-mail">
        <path
          data-name="Tracciato 29"
          d="M3.952 6h7.62a.955.955 0 0 1 .952.952v5.715a.955.955 0 0 1-.952.952h-7.62A.955.955 0 0 1 3 12.667V6.952A.955.955 0 0 1 3.952 6z"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          transform="translate(-2.304 -5.5)"
        />
        <path
          data-name="Tracciato 30"
          d="m12.524 9-4.762 3.334L3 9"
          transform="translate(-2.304 -7.548)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  ),
  [SvgType.MapIcon]: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10.917"
      height="8.62"
      viewBox="0 0 10.917 8.62"
    >
      <g data-name="Icon feather-mail">
        <path
          data-name="Tracciato 29"
          d="M3.952 6h7.62a.955.955 0 0 1 .952.952v5.715a.955.955 0 0 1-.952.952h-7.62A.955.955 0 0 1 3 12.667V6.952A.955.955 0 0 1 3.952 6z"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          transform="translate(-2.304 -5.5)"
        />
        <path
          data-name="Tracciato 30"
          d="m12.524 9-4.762 3.334L3 9"
          transform="translate(-2.304 -7.548)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  ),
  [SvgType.Note]: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11.659"
      height="11.757"
      viewBox="0 0 11.659 11.757"
    >
      <g data-name="Icon feather-edit">
        <path
          data-name="Tracciato 17"
          d="M7.768 6H4.059A1.059 1.059 0 0 0 3 7.059v7.416a1.059 1.059 0 0 0 1.059 1.059h7.416a1.059 1.059 0 0 0 1.059-1.059v-3.707"
          transform="translate(-2.5 -4.278)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          data-name="Tracciato 18"
          d="M17.562 3.147a1.124 1.124 0 0 1 1.589 1.589l-5.032 5.033L12 10.3l.53-2.119z"
          transform="translate(-8.322 -2.22)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  ),
  [SvgType.ActiveEvent]: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <circle data-name="Ellisse 6" cx="8" cy="8" r="8" fill="#0bac55" />
    </svg>
  ),
  [SvgType.Headphones]: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="31.5"
      viewBox="0 0 36 31.5"
      fill="white"
    >
      <path
        id="Icon_awesome-headphones-alt"
        data-name="Icon awesome-headphones-alt"
        d="M11.25,20.25H10.125a4.5,4.5,0,0,0-4.5,4.508v4.483a4.5,4.5,0,0,0,4.5,4.508H11.25A2.253,2.253,0,0,0,13.5,31.5V22.5A2.252,2.252,0,0,0,11.25,20.25Zm14.625,0H24.75A2.252,2.252,0,0,0,22.5,22.5V31.5a2.253,2.253,0,0,0,2.25,2.254h1.125a4.5,4.5,0,0,0,4.5-4.508V24.758a4.5,4.5,0,0,0-4.5-4.508ZM18,2.25c-10.061,0-17.679,8.376-18,18v7.875A1.125,1.125,0,0,0,1.125,29.25H2.25a1.125,1.125,0,0,0,1.125-1.125V20.25a14.625,14.625,0,0,1,29.25,0v7.875A1.125,1.125,0,0,0,33.75,29.25h1.125A1.125,1.125,0,0,0,36,28.125V20.25C35.679,10.626,28.061,2.25,18,2.25Z"
        transform="translate(0 -2.25)"
      />
    </svg>
  ),
  [SvgType.Camera]: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="39.044"
      height="26.03"
      viewBox="0 0 39.044 26.03"
      fill="white"
    >
      <path
        id="Icon_material-video-call"
        data-name="Icon material-video-call"
        d="M34.868,18.761V11.169A2.176,2.176,0,0,0,32.7,9H6.669A2.176,2.176,0,0,0,4.5,11.169V32.86A2.176,2.176,0,0,0,6.669,35.03H32.7a2.176,2.176,0,0,0,2.169-2.169V25.269l8.677,8.677V10.085ZM28.36,24.184H21.853v6.507H17.515V24.184H11.007V19.846h6.507V13.338h4.338v6.507H28.36Z"
        transform="translate(-4.5 -9)"
      />
    </svg>
  ),
  [SvgType.Wallet]: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="27"
      viewBox="0 0 33 27"
      fill="white"
    >
      <path
        id="Icon_material-featured-play-list"
        data-name="Icon material-featured-play-list"
        d="M31.5,4.5H4.5a3.009,3.009,0,0,0-3,3v21a3.009,3.009,0,0,0,3,3h27a3.009,3.009,0,0,0,3-3V7.5A3.009,3.009,0,0,0,31.5,4.5ZM18,16.5H4.5v-3H18Zm0-6H4.5v-3H18Z"
        transform="translate(-1.5 -4.5)"
      />
    </svg>
  ),
  [SvgType.Wine]: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18.637"
      height="33.133"
      viewBox="0 0 18.637 33.133"
      fill="white"
    >
      <path
        id="Icon_awesome-wine-glass-alt"
        data-name="Icon awesome-wine-glass-alt"
        d="M13.978,30.027H11.389V22.443A9.361,9.361,0,0,0,18.6,12.467L17.566.942A1.027,1.027,0,0,0,16.55,0H2.088A1.026,1.026,0,0,0,1.072.942L.039,12.468a9.361,9.361,0,0,0,7.209,9.976v7.583H4.659a2.589,2.589,0,0,0-2.589,2.589.518.518,0,0,0,.518.518h13.46a.518.518,0,0,0,.518-.518A2.589,2.589,0,0,0,13.978,30.027ZM4,3.106H14.641l.464,5.177H3.532Z"
        transform="translate(0)"
      />
    </svg>
  ),
  [SvgType.SvgUrl]: (options?: IconOptions) => (
    <img src={options?.url!} alt="" width="70" height="70" />
  ),
  [SvgType.InfoCsv]: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="13"
      viewBox="0 0 13 13"
    >
      <path
        data-name="Icon awesome-info-circle"
        d="M7.063.563a6.5 6.5 0 1 0 6.5 6.5 6.5 6.5 0 0 0-6.5-6.5zm0 2.883a1.1 1.1 0 1 1-1.1 1.1 1.1 1.1 0 0 1 1.1-1.1zM8.53 10.1a.315.315 0 0 1-.315.315H5.909a.315.315 0 0 1-.315-.315v-.626a.315.315 0 0 1 .315-.315h.315V7.482h-.315a.315.315 0 0 1-.315-.315v-.629a.315.315 0 0 1 .315-.315h1.678a.315.315 0 0 1 .315.315v2.621h.315a.315.315 0 0 1 .315.315z"
        transform="translate(-.563 -.563)"
        fill="#f4f4f4"
      />
    </svg>
  ),
  [SvgType.ReloadCsv]: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17.198"
      height="17.208"
      viewBox="0 0 17.198 17.208"
    >
      <path
        data-name="Icon material-refresh"
        d="M20.685 8.527a8.606 8.606 0 1 0 2.237 8.228h-2.237a6.45 6.45 0 1 1-6.077-8.6 6.362 6.362 0 0 1 4.539 1.914l-3.463 3.463h7.529V6z"
        transform="translate(-6.015 -6)"
        fill="#fff"
      />
    </svg>
  ),
  [SvgType.AlertTb]: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29.25"
      height="29.25"
      viewBox="0 0 29.25 29.25"
    >
      <path
        data-name="Icon ionic-md-alert"
        d="M18 3.375A14.625 14.625 0 1 0 32.625 18 14.668 14.668 0 0 0 18 3.375zm1.688 21.938h-3.375V22.5h3.375zm0-6.187h-3.375v-9h3.375z"
        transform="translate(-3.375 -3.375)"
        fill="#fc4545"
      />
    </svg>
  ),
  [SvgType.HandleAttendees]: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11.659"
      height="11.757"
      viewBox="0 0 11.659 11.757"
    >
      <g data-name="Icon feather-edit">
        <path
          data-name="Tracciato 17"
          d="M7.768 6H4.059A1.059 1.059 0 0 0 3 7.059v7.416a1.059 1.059 0 0 0 1.059 1.059h7.416a1.059 1.059 0 0 0 1.059-1.059v-3.707"
          transform="translate(-2.5 -4.278)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          data-name="Tracciato 18"
          d="M17.562 3.147a1.124 1.124 0 0 1 1.589 1.589l-5.032 5.033L12 10.3l.53-2.119z"
          transform="translate(-8.322 -2.22)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  ),
  [SvgType.AlertDuplicateAttendees]: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="13"
      viewBox="0 0 13 13"
    >
      <path
        data-name="Icon ionic-md-alert"
        d="M6.5 0A6.5 6.5 0 1 0 13 6.5 6.519 6.519 0 0 0 6.5 0zm.75 9.75h-1.5V8.5h1.5zm0-2.75h-1.5V3h1.5z"
      />
    </svg>
  ),
  [SvgType.MinusServices]: () => (
    <svg
      width="28"
      height="28"
      viewBox="0 0 57 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="28.75" cy="28.25" r="28.25" fill="#FFFFFF" />
      <rect
        x="16.75"
        y="31.25"
        width="6"
        height="24"
        transform="rotate(-90 16.75 31.25)"
        fill="#3B7CB0"
      />
    </svg>
  ),
};

export interface IconOptions {
  size?: 'big' | 'small' | 'medium';
  url?: string;
  color?: string;
}

export interface IconProps {
  type: SvgType;
  options?: IconOptions;
}

// @ts-ignore
export const SvgImage = (props: IconProps) =>
  Svg[props.type] ? Svg[props.type](props.options) : null;
